<script setup>
import {ref, onMounted, onBeforeUnmount} from "vue";

const props = defineProps({
  // 锚点组件需要展示的内容
  links: {
    required: true,
    type: Array,
    default: [
      {
        // 锚点
        href: "#step1",
        // 标题
        title: "步骤1",
        // 是否填写完成;适配发布活动，默认情况下传false
        filled: false,
        // 时间节点
        timePoint: ""
      }
    ]
  },
  // 是否展示已超时发货
  isShowOverdue: {
    type: Boolean,
    default: false
  },
  // 是否标题换行
  isTitleWrap: {
    type: Boolean,
    default: true
  }
})

onMounted(() => {

});

// 当前激活的href
const activeHref = ref("")
</script>

<template>
  <div class="yt_anchor_box flex_center flex_left">
    <div
        v-for="(item, index) in props.links"
        :key="`anchor${index}`"
        :class="['yt_anchor_item', { last: index + 1 === props.links.length }]"
    >
      <div class="yt_anchor_step_row" :style="isTitleWrap ? '' : 'min-height: 30px;'">
        <div class="yt_anchor_step_content">
          <div :class="[{flex_center: !isTitleWrap}]">
            <div :class="['flex_center', {mg_b_2: isTitleWrap}, {mg_r_1: !isTitleWrap}]">
              <div :class="['yt_anchor_pre_box flex_center', { filled: item.filled }]">
                <div v-if="!item.filled">{{index + 1}}</div>
                <img v-else style="width: 19px;height: 13px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/component_anchor_checked.svg"/>
              </div>
            </div>
            <div :class="['yt_anchor_title', {active: activeHref === item.href}]">
              {{item.title}}
            </div>
          </div>
          <div class="yt_anchor_timePoint" style="margin-top: 15px;">
            {{item.timePoint}}
          </div>
          <div class="yt_anchor_overdue" v-if="props.isShowOverdue && index === 2">
            已超时未发货
          </div>
        </div>
        <div :style="isTitleWrap ? '' : 'margin-left: 30px;margin-right: 30px;'" :class="['yt_anchor_spacer_dashed', {active: item.filled}]" v-if="index + 1 < props.links.length"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.yt_anchor_box {
  box-sizing: border-box;
  padding: 35px 20px;
  font-family: OPPOSans;
  width: 100%;
  .filled {
    background-color: #796CB4!important;
  }
  .yt_anchor_item {
    display: flex;
    flex: 1 1 0;
    min-width: 0;
    max-width: 350px;

    &.last {
      flex: 0 0 auto;
      max-width: none;
    }
  }
  .yt_anchor_step_row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    min-height: 124px;
  }
  .yt_anchor_step_content {
    flex: 0 0 auto;
  }
  .yt_anchor_pre_box {
    width: 33px;
    height: 33px;
    background: #F3F3F3;
    border-radius: 50%;
    line-height: 33px;
  }
  .yt_anchor_title {
    color: #A7A7A7;
  }
  .active {
    color: #000000;
    font-weight: 500!important;
  }
  .yt_anchor_spacer_dashed {
    box-sizing: border-box;
    flex: 1 1 74px;
    min-width: 74px;
    max-width: 172px;
    height: 1px;
    margin: 17px 15px 0;
    background: repeating-linear-gradient(
            to right,
            #BABABA 0 6px,
            transparent 6px 10px
    );
    &.active {
      background: repeating-linear-gradient(
              to right,
              #D3C6FF 0 6px,
              transparent 6px 10px
      );
    }
  }
  .yt_anchor_timePoint {
    max-width: 80px;
    max-height: 32px;
    font-weight: 500;
    font-size: 12px;
    color: #919191;
    line-height: 16px;
  }
  .yt_anchor_overdue {
    height: 21px;
    background: #FFEFED;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 0 8px;
    font-weight: 500;
    font-size: 12px;
    color: #E45757;
    line-height: 21px;
  }
}

</style>
